import React, { useMemo } from "react";
import { times } from "ramda";
import { Pager } from "../../components";
import Skeleton from "react-loading-skeleton";
// import { tableHeaders } from "./devices-page";

const DevicesTableSkeleton = ({ tenantConfig, line = 1 }) => {
  // Rebuilt only when the row count changes; uuid keys used to remount every
  // placeholder cell on each render.
  const skeletonLines = useMemo(
    () =>
      times(
        (i) => (
          <tr key={i}>
            {times(
              (col) => (
                <td key={col}>
                  <Skeleton />
                </td>
              ),
              9
            )}
          </tr>
        ),
        line
      ),
    [line]
  );

  const tableHeaders = tenantConfig.devices_headers;

  const columnStyle = useMemo(() => ({ padding: "10px" }), []);

  return (
    !!tenantConfig.slug && (
      <>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr style={{ height: "40px" }}>
                {tableHeaders.map((header, idx) => (
                  <th key={idx}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>{skeletonLines}</tbody>
          </table>
        </div>
        <div className="d-flex justify-content-lg-end pagination-box">
          <Pager />
        </div>
      </>
    )
  );
};

export default DevicesTableSkeleton;
